import React , { Component } from 'react';
import { connect } from 'react-redux';
import MiniSpinner from '../../General/MiniSpinner';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { fetchEstadosLiquidaciones } from '../../../actions/LiquidacionesActions';
import { fetchResultadosLiquidaciones } from '../../../actions/LiquidacionesActions';
import Select from 'react-select';
import { customStyleFilter, DropDownArrow, filterSelectMenuPortalProps } from '../../../template/CustomStyle';
import { toast } from '../../../utilities/appToast';
//import {  } from "../../../template/CustomStyle";
import { currencyFormat } from '../../../helper/publicacionHelper';
import { getResultadosLiquidaciones } from '../../../api/axios.js';
import { exportToExcel } from '../../../components/General/Excel/ExcelExportHelper';
import '../Exportables.css';

class ExportarNovedades extends Component {

    constructor(props) {
        super(props);
        this.state = {
            request: null,
            hideSpinner: true,
            estadoCheckbox: false,
            loadingSellersOptions: false,
            loadingEstadosOptions: false,
            datosExcelFormateados: null,
            comboLiquidacionSeller: { label: "", value: "" },
            comboLiquidacionEstado: { label: "", value: "" },
            fechaDesde: "",
            fechaDesdePredeterminado: "",
            fechaHasta: "",
            fechaHastaPredeterminado: "",
            ordenDeReferencia: ""
        }
    };

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    componentDidMount() {

        let fecha = new Date();
        fecha.setDate(fecha.getDate() - 15);
        let fechaNewQuince = fecha.toISOString().slice(0, 10);
        let fechaActual = new Date();
        fechaActual.setDate(fechaActual.getDate());
        let fechaNewActual = fechaActual.toISOString().slice(0, 10);
        this.setState({
            fechaDesde: fechaNewQuince,
            fechaDesdePredeterminado: fechaNewQuince,
            fechaHasta: fechaNewActual,
            fechaHastaPredeterminado: fechaNewActual
        });

        localStorage.removeItem("ListLiquidacionesSeller");
        localStorage.removeItem("ListLiquidacionesEstado");
        localStorage.removeItem("ListLiquidacionesFechaDesde");
        localStorage.removeItem("ListLiquidacionesFechaHasta");
        localStorage.removeItem("ListLiquidacionesEliminaNovedad");
        localStorage.removeItem("ListLiquidacionesOrdenDeReferencia");
        localStorage.setItem('ListLiquidacionesEstado', 1);
    }

    onChangePayMount = (event) => {

        let publicacion = "";
        let isMoney = (event.target.name == "id_a_editar_importe") ? true : false;

        if (isMoney) {
            publicacion = currencyFormat(event.target.value);
        } else {
            publicacion = event.target.value;
        }
        if (publicacion == "NaN") {
            publicacion = "";
        }

        this.setState({ inputValue: publicacion });
    }

    busquedaParaDescargarExcel = () => {

        if (this.state.estadoCheckbox === true) {

            this.setState({hideSpinner: false});
            const listaOrdenesExcel = [];
    
            if (this.state.fechaDesde === "") {
                toast.error("Debe seleccionar una fecha inicial");
                this.setState({ hideSpinner: true });
                return;
            }
            if (this.state.fechaHasta === "") {
                toast.error("Debe seleccionar una fecha final");
                this.setState({ hideSpinner: true });
                return;
            }
          
            // Mantengo localStorage por compatibilidad con otras pantallas, pero el export usa request explícito.
            localStorage.setItem('ListLiquidacionesFechaDesde', this.state.fechaDesde);
            localStorage.setItem('ListLiquidacionesFechaHasta', this.state.fechaHasta);

            const request = {
                fechaDesde: this.state.fechaDesde,
                fechaHasta: this.state.fechaHasta,
                buscaTodo: 1,
                idSeller: 0,
                idEstado: 0,
                ordenDeReferencia: 0
            };

            getResultadosLiquidaciones(request).then(res => {
    
                var objeto = res['novedades'];
            
                for (var j in objeto) {
    
                    let cargaNovedadesExcel = {
                        seller: objeto[j]['seller'],
                        fecha: objeto[j]['fechaNovedad'],
                        ordenDeReferencia: objeto[j]['ordenDeReferencia'],
                        concepto: objeto[j]['detalleTipoNovedad'],
                        estado: objeto[j]['detalleEstadoNovedad'],
                        comentarios: objeto[j]['comentarios'],
                        importe: objeto[j]['importe']
                    };
                    listaOrdenesExcel.push(cargaNovedadesExcel);
                }
    
                this.setState({
                    datosExcelFormateados: listaOrdenesExcel,
                    hideSpinner: true
                })
    
                var link = null;
                link = document.getElementById('btnDescargaExcel');
                link.click();
            }).catch(() => {
                toast.error("No se pudo preparar el archivo de novedades");
            }).finally(() => {
                this.setState({ hideSpinner: true });
            });
        } 
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {

        const label = String(options?.label ?? "");
        const value = (options?.value ?? "").toString();
        let valor = { label, value };
        this.setState({
            comboLiquidacionSeller: valor
        })
        localStorage.setItem('ListLiquidacionesSeller', value);

    }

    selectSearchHandlerLiquidacionesEstado = (options) => {

        const label = String(options?.label ?? "");
        const value = (options?.value ?? "").toString();
        let valor = { label, value };
        this.setState({
            comboLiquidacionEstado: valor
        })
        localStorage.setItem('ListLiquidacionesEstado', value);
    }

    mapSellers = async () => {
        // Carga lazy: si ya existe en Redux, reutilizar sin volver a consultar.
        if (Array.isArray(this.props.filteredSellers) && this.props.filteredSellers.length > 0) {
            return;
        }

        this.setState({ loadingSellersOptions: true });
        try {
            await this.props.fetchSellersFilter({
                Descripcion: "",
                Page: 1,
                PageSize: 100
            });
        } finally {
            this.setState({ loadingSellersOptions: false });
        }
    }

    onSelectSearchInputSellers = (descripcion, action) => {
        if (action.action === 'input-change') {
            const termino = (descripcion ?? "").trim();

            // Si se limpió la búsqueda y ya hay datos cacheados, no repetir llamada.
            if (!termino && Array.isArray(this.props.filteredSellers) && this.props.filteredSellers.length > 0) {
                return descripcion;
            }

            this.setState({ loadingSellersOptions: true });
            Promise.resolve(this.props.fetchSellersFilter({
                Descripcion: termino,
                Page: 1,
                PageSize: 100
            })).finally(() => {
                this.setState({ loadingSellersOptions: false });
            });
        }

        return descripcion;
    }

    mapEstados = async () => {
        // Carga lazy: consulta solo al abrir el select y cachea en Redux para reutilizar.
        if (Array.isArray(this.props.lista_estados_liquidaciones) && this.props.lista_estados_liquidaciones.length > 0) {
            return;
        }

        this.setState({ loadingEstadosOptions: true });
        try {
            await this.props.fetchEstadosLiquidaciones();
        } finally {
            this.setState({ loadingEstadosOptions: false });
        }
    }


    render() {

        const listaSellers = Array.isArray(this.props.filteredSellers)
            ? this.props.filteredSellers.map(s => ({
                label: String(s?.label ?? ""),
                value: (s?.value ?? "").toString()
            }))
            : [];

        let selectListaSellers = 
        <div style={{
            position: "relative",
            left: "-15px",
            paddingBottom: "10px"
        }} className="col-lg-12">
            <p className="font-bold">Seller</p>
            <Select
                name="ListLiquidacionesSeller"
                id="ListLiquidacionesSeller"
                value={this.state.comboLiquidacionSeller}
                options={listaSellers}
                isLoading={this.state.loadingSellersOptions}
                loadingMessage={() => "Buscando..."}
                onChange={this.selectSearchHandlerLiquidacionesSeller}
                onMenuOpen={this.mapSellers}
                onInputChange={this.onSelectSearchInputSellers}
                styles={customStyleFilter}
                {...filterSelectMenuPortalProps}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>

        // INICIO - COMBO DE LISTA DE ESTADOS DE LIQUIDACIONES
        let tipoValEstados = null;
        let listaTipoEstados = [];
        if (Array.isArray(this.props.lista_estados_liquidaciones)) {
            this.props.lista_estados_liquidaciones.forEach((tipo) => {
                const value = (tipo?.value ?? tipo?.idEstado ?? tipo?.IdEstado ?? "").toString();
                const label = String(tipo?.label ?? tipo?.descripcion ?? tipo?.Descripcion ?? "");

                if (!value || !label) return;

                if ((tipo?.idEstado ?? tipo?.IdEstado ?? tipo?.value ?? "") == this.props.lista_estados_liquidaciones.idEstado) {
                    tipoValEstados = { label, value }
                }

                listaTipoEstados.push({ label, value })
            })
        }

        let selectListaEstados = 
        <div style={{
            position: "relative",
            left: "-15px",
            paddingBottom: "10px"
        }} className="col-lg-12">
            <p className="font-bold">Estados</p>
            <Select
                name="ListLiquidacionesIdestado"
                id="ListLiquidacionesIdestado"
                value={this.state.comboLiquidacionEstado}
                options={listaTipoEstados}
                isLoading={this.state.loadingEstadosOptions}
                loadingMessage={() => "Buscando..."}
                onChange={this.selectSearchHandlerLiquidacionesEstado}
                onMenuOpen={this.mapEstados}
                styles={customStyleFilter}
                {...filterSelectMenuPortalProps}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>
        // FIN - COMBO DE LISTA DE ESTADOS DE LIQUIDACIONES

        return (
            <div className="container exportables-page">
            <div className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded admin-page-heading" style={{ background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)', borderLeft: '4px solid var(--rojo-megatone, #c00)' }}>
                <div className="col-12 col-md-7">
                    <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Exportables - Novedades</h4>
                    <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                        Exportación de novedades por rango de fechas y filtros.
                    </p>
                </div>

                <div className="col-12 col-md-3 mt-2 mt-md-0 button-group align-self-center text-md-end d-none d-md-block">
                    {!this.state.hideSpinner && (
                        <div className="d-flex align-items-center gap-2">
                            <MiniSpinner />
                            <span className="small text-muted">Buscando...</span>
                        </div>
                    )}
                </div>

                <div className="col-12 col-md-2 mt-2 mt-md-0 button-group text-md-end">

                    <button type="button" onClick={this.busquedaParaDescargarExcel} className="btn btn-sm btn-green" disabled={!this.state.estadoCheckbox}>Descargar Excel</button>

                    <button 
                        id="btnDescargaExcel" 
                        type="button" 
                        hidden={true} 
                        className="btn btn-sm"
                        onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Novedades', 'Novedades')}
                    >
                        Descargar Excel
                    </button>

                </div>
            </div>

                <div className="exportables-filter-shell">
                <div className="card card-body filter-card exportables-filter-card">
                    <div className="row form-material">

                        <div className="col-md-2">
                            <p className="font-bold">Desde</p>
                            <input 
                                type="date" 
                                name="ListLiquidacionesFechaDesde" 
                                id="ListLiquidacionesFechaDesde" 
                                className="form-control" 
                                value={this.state.fechaDesde}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="col-md-2">
                            <p className="font-bold">Hasta</p>
                            <input 
                                type="date" 
                                name="ListLiquidacionesFechaHasta" 
                                id="ListLiquidacionesFechaHasta" 
                                className="form-control" 
                                value={this.state.fechaHasta}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="col-3">
                            {selectListaSellers}
                        </div>

                        <div className="col-3">
                            {selectListaEstados}
                        </div>

                        <div className="col-md-2">
                            <p className="font-bold">Orden De Referencia</p>
                            <input 
                                type="number" 
                                name="ordenDeReferencia"
                                id="ListLiquidacionesOrdenDeReferencia" 
                                className="form-control"
                                value={this.state.ordenDeReferencia}
                                onChange={this.myChangeHandler}
                            />
                        </div>
                    </div>

                    <div className="ibox-content float-e-margins">
                        <input 
                            type="checkbox" 
                            onChange={(e) => this.setState({estadoCheckbox: e.target.checked})} 
                            id="BuscaTodo"
                        /> 
                        <label htmlFor="BuscaTodo">
                            Todas las novedades de todos los sellers en el rango de tiempo
                        </label>
                    </div>

                </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    filteredSellers: state.sellers.filteredSellers,
    tipoUsuario: state.general.tipoUsuario,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    lista_resultado_liquidaciones: state.liquidaciones.lista_resultados_liquidaciones
});

export default connect(mapStateToProps, { 
    fetchSellersFilter,
    fetchEstadosLiquidaciones, 
    fetchResultadosLiquidaciones 
}) (ExportarNovedades);